export const toKebabCase = (key: string) =>
	key
		.replace(/\./g, '_')
		.replace(/([A-Z])/g, (upperLetter) => `-${upperLetter.toLowerCase()}`)
